var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemPlanBuilder = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 448,
  height: 150,
  fill: "none",
  viewBox: "0 0 448 150",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h448v150H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 448,
  height: 150,
  fill: "#EAF2FF",
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  width: 404,
  height: 184,
  x: 22,
  y: 15,
  fill: "url(#b)",
  fillOpacity: 0.23,
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  width: 378,
  height: 161,
  x: 42,
  y: 21,
  fill: "#fff",
  fillOpacity: 0.2,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.4,
  d: "M52 35h357v31H52z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "transparent",
  stroke: "#5D29E2",
  strokeLinecap: "round",
  d: "m55 58 23.5-8.842 48 8.842 44.5-7.368 21 5.157 19.5-6.631 23 3.684 20-8.842 18 14L290 44",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "transparent",
  stroke: "#0048EE",
  strokeLinecap: "round",
  d: "m58 64 10.023-3.75h16.538l12.027-4.5 20.046 4.5 9.021-8.25 43.099 8.25h46.607l36.584-4.5L276 46",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  x: 6,
  y: 8,
  fill: "#2A70EA",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 9,
  height: 9,
  x: 28,
  y: 44,
  fill: "#9BB9EC",
  fillOpacity: 0.9,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 9,
  height: 9,
  x: 28,
  y: 56,
  fill: "#9BB9EC",
  fillOpacity: 0.5,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 9,
  height: 9,
  x: 28,
  y: 69,
  fill: "#9BB9EC",
  fillOpacity: 0.2,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 4,
  x: 52,
  y: 26,
  fill: "#318FE6",
  fillOpacity: 0.25,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 4,
  x: 92,
  y: 26,
  fill: "#318FE6",
  fillOpacity: 0.25,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 4,
  x: 106,
  y: 26,
  fill: "#318FE6",
  fillOpacity: 0.25,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 4,
  x: 255,
  y: 26,
  fill: "#318FE6",
  fillOpacity: 0.25,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 4,
  x: 269,
  y: 26,
  fill: "#318FE6",
  fillOpacity: 0.25,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 37,
  height: 4,
  x: 120,
  y: 26,
  fill: "#318FE6",
  fillOpacity: 0.25,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 37,
  height: 4,
  x: 283,
  y: 26,
  fill: "#318FE6",
  fillOpacity: 0.25,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 37,
  height: 4,
  x: 353,
  y: 26,
  fill: "#318FE6",
  fillOpacity: 0.25,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 4,
  x: 393,
  y: 26,
  fill: "#318FE6",
  fillOpacity: 0.25,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 57,
  height: 4,
  x: 195,
  y: 26,
  fill: "#318FE6",
  fillOpacity: 0.25,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M29.587 13.161a3.25 3.25 0 0 1 3.252 3.252v15.174a3.25 3.25 0 0 1-3.252 3.252H14.413a3.25 3.25 0 0 1-3.252-3.252V16.413a3.25 3.25 0 0 1 3.252-3.252zm-16.258 8.671h6.503a1.084 1.084 0 0 1 0 2.168h-6.503v7.587c0 .598.486 1.084 1.084 1.084h15.174c.599 0 1.084-.486 1.084-1.084v-1.084h-6.503a1.084 1.084 0 0 1 0-2.168h6.503v-8.67H13.329zm14.09 3.252a1.084 1.084 0 0 1 0 2.168H16.582a1.084 1.084 0 0 1 0-2.168zm-13.006-9.755c-.598 0-1.084.486-1.084 1.084v1.084h17.342v-1.084c0-.598-.485-1.084-1.084-1.084z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 181,
  height: 39,
  x: 48,
  y: 79,
  fill: "#A8C5F5",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 173,
  height: 39,
  x: 236,
  y: 79,
  fill: "#A8C5F5",
  fillOpacity: 0.5,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 181,
  height: 39,
  x: 11,
  y: 71,
  fill: "#2A70EA",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 52,
  height: 6,
  x: 15,
  y: 76,
  fill: "#fff",
  fillOpacity: 0.5,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 148,
  height: 17,
  x: 47,
  y: 123,
  fill: "#4CD96A",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 5,
  x: 50,
  y: 126,
  fill: "#fff",
  fillOpacity: 0.5,
  rx: 2.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 148,
  height: 17,
  x: 201,
  y: 123,
  fill: "#5D29E2",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 5,
  x: 204,
  y: 126,
  fill: "#fff",
  fillOpacity: 0.5,
  rx: 2.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 84,
  height: 17,
  x: 355,
  y: 123,
  fill: "#FF61DD",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 5,
  x: 358,
  y: 126,
  fill: "#fff",
  fillOpacity: 0.5,
  rx: 2.5
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: -14.973,
  x2: 444.353,
  y1: 186.733,
  y2: 117.848,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#183F84"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.346,
  stopColor: "#2A70EA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.923,
  stopColor: "#5D29E2"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h448v150H0z"
})))));
export default SvgGemPlanBuilder;